const propertyTypeLabels = {
  residential: 'Residential',
  apartment: 'Apartment',
  villa: 'Villa',
};

export const submitPropertyForm = async (formData) => {
  return new Promise((resolve, reject) => {
    // Create a hidden form for file uploads (FormSubmit works better with actual form submission)
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://formsubmit.co/majd@royal-vista.com';
    form.enctype = 'multipart/form-data';
    form.style.display = 'none';

    // Add subject
    const subjectInput = document.createElement('input');
    subjectInput.type = 'hidden';
    subjectInput.name = '_subject';
    subjectInput.value = 'Listing page submission';
    form.appendChild(subjectInput);

    // Personal Info
    const firstNameInput = document.createElement('input');
    firstNameInput.type = 'hidden';
    firstNameInput.name = 'First Name';
    firstNameInput.value = formData.firstName || 'Not provided';
    form.appendChild(firstNameInput);

    const lastNameInput = document.createElement('input');
    lastNameInput.type = 'hidden';
    lastNameInput.name = 'Last Name';
    lastNameInput.value = formData.lastName || 'Not provided';
    form.appendChild(lastNameInput);

    const emailInput = document.createElement('input');
    emailInput.type = 'hidden';
    emailInput.name = 'Email';
    emailInput.value = formData.email || 'Not provided';
    form.appendChild(emailInput);

    const phoneInput = document.createElement('input');
    phoneInput.type = 'hidden';
    phoneInput.name = 'Phone';
    phoneInput.value = formData.phone || 'Not provided';
    form.appendChild(phoneInput);

    // Property Type
    const propertyTypeInput = document.createElement('input');
    propertyTypeInput.type = 'hidden';
    propertyTypeInput.name = 'Property Type';
    propertyTypeInput.value = formData.propertyType ? propertyTypeLabels[formData.propertyType] || formData.propertyType : 'Not specified';
    form.appendChild(propertyTypeInput);

    // Property Details
    const titleInput = document.createElement('input');
    titleInput.type = 'hidden';
    titleInput.name = 'Property Title';
    titleInput.value = formData.propertyTitle || 'Not provided';
    form.appendChild(titleInput);

    const descriptionInput = document.createElement('textarea');
    descriptionInput.name = 'Description';
    descriptionInput.value = formData.description || 'Not provided';
    descriptionInput.style.display = 'none';
    form.appendChild(descriptionInput);

    // Address
    const cityInput = document.createElement('input');
    cityInput.type = 'hidden';
    cityInput.name = 'City';
    cityInput.value = formData.city || 'Not provided';
    form.appendChild(cityInput);

    const streetInput = document.createElement('input');
    streetInput.type = 'hidden';
    streetInput.name = 'Street';
    streetInput.value = formData.street || 'Not provided';
    form.appendChild(streetInput);

    const buildingInput = document.createElement('input');
    buildingInput.type = 'hidden';
    buildingInput.name = 'Building';
    buildingInput.value = formData.building || 'Not provided';
    form.appendChild(buildingInput);

    const zipCodeInput = document.createElement('input');
    zipCodeInput.type = 'hidden';
    zipCodeInput.name = 'Zip Code';
    zipCodeInput.value = formData.zipCode || 'Not provided';
    form.appendChild(zipCodeInput);

    // Features
    const floorsInput = document.createElement('input');
    floorsInput.type = 'hidden';
    floorsInput.name = 'Floors';
    floorsInput.value = formData.floors !== null ? String(formData.floors) : 'Not provided';
    form.appendChild(floorsInput);

    const parkingInput = document.createElement('input');
    parkingInput.type = 'hidden';
    parkingInput.name = 'Parking Spaces';
    parkingInput.value = formData.parkingSpaces !== null ? String(formData.parkingSpaces) : 'Not provided';
    form.appendChild(parkingInput);

    const bedroomsInput = document.createElement('input');
    bedroomsInput.type = 'hidden';
    bedroomsInput.name = 'Bedrooms';
    bedroomsInput.value = formData.bedrooms !== null ? String(formData.bedrooms) : 'Not provided';
    form.appendChild(bedroomsInput);

    const bathroomsInput = document.createElement('input');
    bathroomsInput.type = 'hidden';
    bathroomsInput.name = 'Bathrooms';
    bathroomsInput.value = formData.bathrooms !== null ? String(formData.bathrooms) : 'Not provided';
    form.appendChild(bathroomsInput);

    const furnishingInput = document.createElement('input');
    furnishingInput.type = 'hidden';
    furnishingInput.name = 'Furnishing Status';
    furnishingInput.value = formData.furnishingStatus || 'Not provided';
    form.appendChild(furnishingInput);

    const balconiesInput = document.createElement('input');
    balconiesInput.type = 'hidden';
    balconiesInput.name = 'Balconies';
    balconiesInput.value = formData.balconies !== null ? String(formData.balconies) : 'Not provided';
    form.appendChild(balconiesInput);

    const conditionInput = document.createElement('input');
    conditionInput.type = 'hidden';
    conditionInput.name = 'Condition';
    conditionInput.value = formData.condition || 'Not provided';
    form.appendChild(conditionInput);

    // FormSubmit options
    const captchaInput = document.createElement('input');
    captchaInput.type = 'hidden';
    captchaInput.name = '_captcha';
    captchaInput.value = 'false';
    form.appendChild(captchaInput);

    const templateInput = document.createElement('input');
    templateInput.type = 'hidden';
    templateInput.name = '_template';
    templateInput.value = 'box';
    form.appendChild(templateInput);

    // Add file attachments if they exist
    if (formData.assets && formData.assets.length > 0) {
      formData.assets.forEach((asset) => {
        if (asset && asset.file && asset.file instanceof File) {
          const fileInput = document.createElement('input');
          fileInput.type = 'file';
          fileInput.name = 'attachment';
          fileInput.style.display = 'none';
          
          // Use DataTransfer to set files
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(asset.file);
          fileInput.files = dataTransfer.files;
          
          form.appendChild(fileInput);
        }
      });
    }

    // Create iframe to submit form without page navigation
    const iframe = document.createElement('iframe');
    iframe.name = 'formsubmit-iframe-' + Date.now();
    iframe.style.display = 'none';
    iframe.style.width = '0';
    iframe.style.height = '0';
    document.body.appendChild(iframe);

    form.target = iframe.name;
    document.body.appendChild(form);

    // Handle iframe load (FormSubmit redirects to success page)
    let resolved = false;
    iframe.onload = () => {
      if (!resolved) {
        resolved = true;
        setTimeout(() => {
          document.body.removeChild(form);
          document.body.removeChild(iframe);
          resolve({ success: true });
        }, 500);
      }
    };

    // Fallback timeout
    setTimeout(() => {
      if (!resolved) {
        resolved = true;
        document.body.removeChild(form);
        document.body.removeChild(iframe);
        resolve({ success: true });
      }
    }, 3000);

    // Submit the form
    form.submit();
  });
};

